import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createPortlet } from '../../../api/managerApi';
import './portlet.css';

const initialForm = {
  portlet_id: '',
  portlet_label: '',
  portlet_context: '',
  sort_order: 0,
  is_active: true,
};

function PortletCreate({ onSuccess, onCancel }) {
  const navigate = useNavigate();
  const [form, setForm] = useState(initialForm);
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        ...form,
        sort_order: Number(form.sort_order || 0),
        is_active: String(form.is_active) === 'true',
      };
      const created = await createPortlet(payload);
      if (onSuccess) {
        onSuccess(created);
      } else {
        navigate('/manager/portlet');
      }
    } catch (err) {
      console.error('포틀릿 생성 실패:', err);
      alert('포틀릿 생성 실패');
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <div className="mgr-panel-header">
        <div>
          <div className="mgr-panel-title">포틀릿 생성</div>
          <div className="mgr-panel-subtitle">새로운 포틀릿 항목을 등록합니다.</div>
        </div>
      </div>
      <div className="mgr-panel-body">
        <form onSubmit={handleSubmit}>
          <div className="mgr-section">
            <div className="mgr-section-title">기본 정보</div>
            <div className="mgr-section-body">
              <div className="row g-2">
                <div className="col-md-5">
                  <label className="form-label">포틀릿 ID</label>
                  <input className="form-control form-control-sm" name="portlet_id" value={form.portlet_id} onChange={handleChange} required placeholder="예: myProfile" />
                </div>
                <div className="col-md-7">
                  <label className="form-label">포틀릿 라벨</label>
                  <input className="form-control form-control-sm" name="portlet_label" value={form.portlet_label} onChange={handleChange} required placeholder="표시 이름" />
                </div>
              </div>
            </div>
          </div>
          <div className="mgr-section">
            <div className="mgr-section-title">기타 설정</div>
            <div className="mgr-section-body">
              <div className="row g-2">
                <div className="col-12">
                  <label className="form-label">포틀릿 설명</label>
                  <textarea
                    className="form-control form-control-sm"
                    name="portlet_context"
                    value={form.portlet_context}
                    onChange={handleChange}
                    rows={3}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">정렬 순서</label>
                  <input className="form-control form-control-sm" type="number" name="sort_order" value={form.sort_order} onChange={handleChange} />
                </div>
                <div className="col-md-3">
                  <label className="form-label">활성 상태</label>
                  <select className="form-select form-select-sm" name="is_active" value={String(form.is_active)} onChange={handleChange}>
                    <option value="true">활성</option>
                    <option value="false">비활성</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="mgr-form-footer">
        <button className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={saving}>{saving ? '저장중...' : '생성'}</button>
        <button className="btn btn-outline-secondary btn-sm" type="button" onClick={() => (onCancel ? onCancel() : navigate(-1))}>취소</button>
      </div>
    </>
  );
}

export default PortletCreate;
